<template>
  <div class="tw-flex">
    <amex-icon class="tw-h-full" v-show="isAmex === true" />
    <diners-club-icon class="tw-h-full" v-show="isDiners === true" />
    <discover-icon class="tw-h-full" v-show="isDiscover === true" />
    <jcb-icon class="tw-h-full" v-show="isJcb === true" />
    <mastercard-icon class="tw-h-full" v-show="isMastercard === true" />
    <union-pay-icon class="tw-h-full" v-show="isUnionPay === true" />
    <visa-icon class="tw-h-full" v-show="isVisa === true" />
  </div>
</template>
<script>
import { AmexIcon, DinersClubIcon, DiscoverIcon, JcbIcon, MastercardIcon, UnionPayIcon, VisaIcon } from "@/assets/svgs";

export default {
  name: "CreditCardIcon",
  components: {
    AmexIcon,
    DinersClubIcon,
    DiscoverIcon,
    JcbIcon,
    MastercardIcon,
    UnionPayIcon,
    VisaIcon,
  },
  props: {
    name: { type: String, default: "" },
  },
  computed: {
    normalizedName() {
      return this.name ? this.name.toLowerCase() : "";
    },
    isAmex() {
      return this.normalizedName === "amex" || this.normalizedName === "american express";
    },
    isDiners() {
      return this.normalizedName === "diners" || this.normalizedName === "diners club";
    },
    isDiscover() {
      return this.normalizedName === "discover";
    },
    isJcb() {
      return this.normalizedName === "jcb";
    },
    isMastercard() {
      return this.normalizedName === "mastercard" || this.normalizedName === "master card";
    },
    isUnionPay() {
      return this.normalizedName === "unionpay";
    },
    isVisa() {
      return this.normalizedName === "visa";
    },
  },
};
</script>
